import axios from '../core/http';

import { APIcallerv2, APIcaller } from '@services/APIcaller';

import { config } from '../config';

const baseApiUrl = `${config.baseApiUrl}/v1`;

const getIngestionPipelineStatus = (clientId) =>
  axios
    .get(`${baseApiUrl}/backoffice/pipelines/ingestion/status`, {
      params: {
        clientId,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

const setIngestionPipelineSchedule = (schedule) =>
  APIcaller.apiPost('/backoffice/pipelines/ingestion/schedule', { schedule });

const retrieveSalesHistory = (clientId) =>
  APIcaller.apiPost('/backoffice/pipelines/ingestion/retrieve-history', { clientId });

const setForecastPipelineSchedule = (schedule) =>
  APIcaller.apiPost('/backoffice/pipelines/forecast/schedule', { schedule });

const getCashierProductsSalesSyncStatus = () =>
  APIcallerv2.apiGet('/cashier-product-sales/sync/status');

const syncCashierProductSales = (storeIds, startDate, endDate) =>
  axios
    .post(`${baseApiUrl}/backoffice/cashier-product-sales/sync`, {
      storeIds,
      startDate,
      endDate,
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

const getForecastPipelineStatus = (clientId) =>
  axios
    .get(`${baseApiUrl}/backoffice/pipelines/forecast/status`, {
      params: {
        clientId,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

const exportCashierProductSales = (startDate, endDate, storeIds) =>
  axios
    .post(
      `${baseApiUrl}/backoffice/cashier-product-sales/export`,
      { startDate, endDate, storeIds },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('loopbackAccessToken'),
        },
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

const activateIngestionPipeline = (clientId) =>
  axios
    .post(`${baseApiUrl}/backoffice/pipelines/ingestion/activate`, {
      clientId,
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

const activateIngestionPipelineStatus = (clientId) =>
  axios
    .get(`${baseApiUrl}/backoffice/pipelines/ingestion/activate/status`, {
      params: {
        clientId,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

const activateForecasts = (clientId) =>
  axios
    .post(`${baseApiUrl}/backoffice/pipelines/forecast/activate`, {
      clientId,
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

export const cashierProductSalesService = {
  getIngestionPipelineStatus,
  setIngestionPipelineSchedule,
  retrieveSalesHistory,
  setForecastPipelineSchedule,
  getCashierProductsSalesSyncStatus,
  syncCashierProductSales,
  exportCashierProductSales,
  activateIngestionPipeline,
  activateIngestionPipelineStatus,
  activateForecasts,
  getForecastPipelineStatus,
};
